const getDefaultState = () => {
    return {
        Geld: {
            icon: "icon-geld",
            label: "Geld",
        },
        Gesundheit: {
            icon: "icon-gesundheit",
            label: "Gesund&shy;heit",
        },
        Mobilität: {
            icon: "icon-mobilitaet",
            label: "Mobilität",
        },
        Wohnen: {
            icon: "icon-wohnen",
            label: "Wohnen",
        },
        Zukunft: {
            icon: "icon-zukunft",
            label: "Zukunft",
        },
        Berater: {
            icon: "icon-berater",
            label: "Berater",
        },
        // "Finanzierungstarif Fixzins": {
        // icon: "icon-mobilitaet",
        // label: "Finanzierungstarif Fixzins"
        // },
        Spontanrückzahlung: {
            icon: "icon-spontanrueckzahlung",
            label: "Spontan&shy;rückzahlung",
        },
        Unwetterwarnung: {
            icon: "icon-unwetter",
            label: "Unwetter&shy;warnung",
        },
        Vertragsdetails: {
            icon: "icon-dokument",
            label: "Vertrags&shy;details",
        },
        Schadensmeldung: {
            icon: "icon-schadensmeldung",
            label: "Schadens&shy;meldung",
        },
        Magazin: {
            icon: "icon-magazin",
        },
        Lebenscheck: {
            icon: "icon-lebenscheck",
            label: "Lebens&shy;Check",
        },
        Beratersuche: {
            icon: "icon-berater_suche",
            label: "Berater&shy;suche",
        },
        Weiterempfehlen: {
            icon: "icon-stern",
            label: "Weiter&shy;empfehlen",
        },
        Einstellungen: {
            icon: "icon-einstellungen",
            label: "Einstel&shy;lungen",
        },
        Impressum: {
            icon: "icon-recht",
            label: "Impres&shy;sum",
        },
        Demo: {
            icon: "icon-smartphone",
            label: "App Demo",
        },
        Kreditcheckliste: {
            label: "Kredit&shy;checkliste",
            icon: "icon-check",
        },
        KFZ: {
            icon: "icon-schadensmeldung_kfz",
            // motive: "mobilitaet"
        },
        "Haushalt & Eigenheim": {
            // motive: "wohnen",
            icon: "icon-schadensmeldung_hheh",
        },
        "Sachvers. Unwetter": {
            icon: "icon-unwetter",
            // motive: "wohnen"
            label: "Unwetter&shy;schaden",
        },
        Rechtsschutz: {
            icon: "icon-recht",
            label: "Rechts&shy;schutz",
        },
        Baugelddarlehen: {
            label: "Baugeld&shy;darlehen",
            icon: "icon-darlehen",
        },
        Anpassen: {
            icon: "icon-anpassen",
        },
        Einzahlung: {
            icon: "icon-einzahlen",
        },
        Auszahlung: {
            icon: "icon-auszahlen",
        },
        Fonds: {
            icon: "icon-fonds",
        },
        Kraftfahrzeugversicherung: {
            label: "Kraftfahr&shy;zeug&shy;versicherung",
            icon: "icon-kfz_versicherung",
        },
        "Finanzierungstarif Fixzins": {
            label: "Finanzierungs&shy;tarif Fixzins",
            icon: "icon-fixzins",
        },
        Eigenheimversicherung: {
            label: "Eigenheim&shy;versicherung",
            icon: "icon-haushalt_und_eigenheim",
        },
        "Dynamischer Spartarif": {
            label: "Dynamischer Spartarif",
            icon: "icon-percent",
        },
        "Smart|Bausparen": {
            label: "Smart|&#8203;Bausparen",
            icon: "icon-sparen",
        },
        Stammkundendarlehen: {
            label: "Stamm&shy;kunden&shy;darlehen",
            icon: "icon-darlehen",
        },
        Krankenvorsorge: {
            label: "Kranken&shy;vorsorge",
            icon: "icon-vorsorge",
        },
        Kinder: {
            label: "Kinder",
            icon: "icon-vorsorge",
        },
        Haushaltversicherung: {
            label: "Haushalt&shy;versicherung",
            icon: "icon-haushalt_und_eigenheim",
        },
        Risikoversicherung: {
            label: "Risiko&shy;versicherung",
            icon: "icon-risiko",
        },
        "Risiko-Vorsorge": {
            label: "Risiko-Vorsorge",
            icon: "icon-risiko",
        },
        "Gehaltsumwandlung Er-/Ableben": {
            label: "Gehalts&shy;umwandlung Er-/Ableben",
            icon: "icon-vorsorge",
        },
        "Überlebensvorsorge Single-Basic": {
            label: "Überlebens&shy;vorsorge Single-Basic",
            icon: "icon-vorsorge",
        },
        FlexibleLife: {
            label: "Flexible&shy;Life",
            icon: "icon-flexiblelife",
        },
        Übersicht: {
            icon: "icon-pie_chart",
        },
        "Voll:Wert/16": {
            label: "Voll:Wert&#8203;/16",
            icon: "icon-vollwert",
        },
        "Voll:Wert": {
            icon: "icon-vollwert",
        },
        Services: {
            icon: "icon-services",
        },
        DokBox: {
            icon: "icon-dokbox",
        },
        "FLEXIBLER Bauspartarif": {
            icon: "icon-sparen",
        },
        "Rechtsschutz PRIVAT": {
            icon: "icon-rechtsschutz",
        },
        "PlusCare Basic": {
            icon: "icon-vorsorge",
        },
        "SMART Bauspartarif": {
            icon: "icon-sparen",
        },
        "Sofortschutz:Leben": {
            label: "Sofortschutz:&#8203;Leben",
            icon: "icon-vorsorge",
        },
        "Kranken-Vorsorge": {
            icon: "icon-vorsorge",
        },
        "Unfall-Vorsorge Familie": {
            icon: "icon-vorsorge",
        },
        "SMART|BAUSPAREN": {
            label: "SMART|&#8203;BAUSPAREN",
            icon: "icon-sparen",
        },
        Finanzierungstarif: {
            label: "Finanzierungs&shy;tarif",
            icon: "icon-darlehen",
        },
        "Überlebensvorsorge Family-Basic": {
            label: "Überlebens&shy;vorsorge Family-Basic",
            icon: "icon-vorsorge",
        },
        "Partner-Ablebens-Vorsorge": {
            icon: "icon-vorsorge",
        },
        "Unfallvorsorge Erwachsener": {
            icon: "icon-vorsorge",
        },
        "Finanzierungstarif FIX PLANBAR": {
            label: "Finanzierungs&shy;tarif FIX PLANBAR",
            icon: "icon-darlehen",
        },
        "Gehaltsumwandlung Erleben": {
            label: "Gehalts&shy;umwandlung Erleben",
            icon: "icon-vorsorge",
        },
        "Über-Lebens-Vorsorge": {
            icon: "icon-vorsorge",
        },
        "Zukunfts-Vorsorge PLUS": {
            icon: "icon-vorsorge",
        },
        "Krankenvorsorge Kinder": {
            label: "Kranken&shy;vorsorge Kinder",
            icon: "icon-vorsorge",
        },
        "Fixzins-Spartarif": {
            icon: "icon-fixzins",
        },
        "Er- und Ablebens-Vorsorge": {
            icon: "icon-vorsorge",
        },
        Sparpolizze: {
            icon: "icon-sparen",
        },
        "Kranken-Vorsorge Kinder": {
            icon: "icon-vorsorge",
        },
        "Partner-Vorsorge": {
            icon: "icon-vorsorge",
        },
        LebensCheck: {
            icon: "icon-lebenscheck",
            label: "Lebens&shy;Check",
        },
        Bautagebuch: {
            icon: "icon-bautagebuch",
        },
        Umsätze: {
            icon: "icon-umsaetze",
            label: "Ein-/Aus&shy;zahlungen",
        },
        "QR Scanner": {
            icon: "icon-qrcode",
        },
        "eBike Tracker": {
            icon: "icon-ebike",
        },
        Newsletter: {
            icon: "icon-newsletter",
        },
        "ImmoWert berechnen": {
            icon: "icon-immowert",
        },
        "Auszahlung Gutschein": {
            icon: "icon-gutschein",
        },
        me1ns: {
            icon: "icon-herz",
        },
        "MY 21": {
            icon: "icon-herz_21",
        },
        Windhund: {
            icon: "icon-fit",
        },
        "Online KFZ-Begutachtung": {
            icon: "icon-kfz_lupe",
        },
        "Grüne Karte herunterladen": {
            icon: "icon-gruene_karte",
        },
        "SEPA Lastschrift-Mandat": {
            icon: "icon-sepa",
        },
        "KFZ neu": {
            icon: "icon-schadensmeldung_kfz",
            motive: "mobilitaet",
            label: "KFZ",
        },
        "Taggeld Krankenhaus": {
            icon: "icon-gesundheit",
            motive: "gesundheit",
        },
        "Rechtsschutz neu": {
            icon: "icon-recht",
            label: "Rechts&shy;schutz",
        },
        Unfallversicherung: {
            icon: "icon-vorsorge",
            label: "Unfall&shy;versicherung",
        },
        "Haushalt & Eigenheim neu": {
            motive: "wohnen",
            icon: "icon-schadensmeldung_hheh",
            label: "Haushalt & Eigenheim",
        },
        "Sachvers. Unwetter neu": {
            icon: "icon-unwetter",
            label: "Unwetter",
        },
        "me1n Zuhause": {
            icon: "icon-me1n_zuhause",
        },
    };
};

const state = getDefaultState();

export default {
    state,
};
